<template>
  <div class="mh4">
    <div class="row mt4 ph4 flex items-center">
      <div class="col-xs-9 warning-text">
        <div class="row">
          <div class="yellow-alert pr2"></div>
          <span class="pl2"
            >The email is already registered in the school, any new data will
            update the existing information for this user.</span
          >
        </div>
        <div class="row">
          <div class="red-warning"></div>
          <span class="pl2">The field should not be empty.</span>
        </div>
        <div class="row">
          <div style="width: 30px"></div>
          <span class="pl2 text-red">The email is not valid.</span>
        </div>
        <div class="row">
          <div style="width: 30px"></div>
          <span class="pl2 text-orange"
            >The role should be teacher or student.</span
          >
        </div>
      </div>
      <div class="col-xs-3 pa3 flex justify-end topics">
        <div
          style="flex-direction: column"
          class="flex justify-center items-center"
        >
          <pl-button
            class="pl-white b"
            style="
              font-size: 18px;
              margin: 0px;
              padding: 0px;
              width: fit-content;
            "
          >
            <label
              for="files"
              style="
                cursor: pointer;
                display: block;
                width: 100%;
                height: 100%;
                padding: 5px;
              "
              :class="[showFile ? 'disable_upload' : '']"
              >Upload CSV File</label
            >
          </pl-button>
          <div
            v-if="showFile"
            class="relative flex justify-center items-center"
            style="
              background-color: #dfe8f2;
              margin-top: 5px;
              width: 170px;
              max-height: 50px;
            "
          >
            <img
              src="/static/online_roundtable_icons/attach_file_icon.svg"
              alt=""
              style="vertical-align: middle"
            />

            <span
              class="col-xs-9 truncate"
              style="
                color: #3b24e3;
                font-size: 18px;
                font-weight: 400;
                padding-left: 5px;
                vertical-align: middle;
                display: inline-block;
                width: 100px;
              "
            >
              {{ file_name }}
            </span>
            <i
              @click="discardFile"
              class="fa fa-close absolute"
              style="
                color: #3b24e3;
                font-size: 14px;
                text-align: right;
                cursor: pointer;
                right: 2px;
                top: 2px;
              "
            ></i>
          </div>
          <a
            href="../../../../static/upload_csv_files/users.csv"
            target="_blank"
            download="users.csv"
            class="topic-link primary b"
            style="text-decoration: none; font-size: 14px; text-align: center"
          >
            Download Template</a
          >
        </div>
        <input
          id="files"
          ref="fileUploader"
          style="visibility: hidden; width: 10px"
          type="file"
          accept=".csv"
          :disabled="showFile"
          @click="resetFileUploader"
          @change="handleFiles($event)"
        />

        <div v-if="csv_has_errors">
          <div v-for="error in csv_error_message" :key="error">
            <p style="color: red">{{ error }}</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!showFile && handlingFile" class="mh2 middle-xs between-xs mb-7">
      <pl-spinner class="x3" style="margin: auto" />
    </div>
    <div class="mh2 middle-xs between-xs mb-7">
      <vue-table
        class="pt5"
        :tbody-data="usersToCheck"
        :headers="headers"
        :custom-options="customOptions"
        :style-wrap-vue-table="styleWrapVueTable"
        :disable-cells="disableCells"
        :disable-sort-thead="disableSortThead"
        :loading="loading"
        :parent-scroll-element="parentScrollElement"
        :select-position="selectPosition"
        :submenu-thead="submenuThead"
        @tbody-checked-row="checkedData"
        @tbody-all-checked-row="checkedAllData"
        @tbody-change-data="checkErrorsInTable"
      >
        <div slot="header" style="margin-bottom: 30px">
          <div class="fw6" style="margin-bottom: 20px" v-if="errors_count > 0">
            You have <label class="red">{{ errors_count }}</label> errors. Fix
            them before proceeding.
          </div>
          <div v-if="canImport">
            <span class="fw6"
              >You don't have any errors in your file, you can proceed to add
              new users.
            </span>
            <div class="w-100 flex items-center justify-center tc pt4">
              <pl-checkbox
                v-model="send_email"
                @change="handleSelect($event)"
              />
              <span class="pl-caption na1"
                >Send email notifications to teachers.</span
              >
            </div>
          </div>

          <div
            class="tr pr1 remove_btn"
            :class="[
              usersToRemove.length === 0 ? 'disable_remove' : 'remove_btn',
            ]"
          >
            <span @click="deleteUser"
              ><i class="fa fa-trash" aria-hidden="true"></i>
              <span style="text-decoration: underline"
                >Remove selected</span
              ></span
            >
          </div>
        </div>

        <div slot="loader">Loader</div>
      </vue-table>
      <pl-button
        class="pl-primary pl-icon"
        style="margin: 5px; float: right"
        @click.native="addRow"
      >
        <i class="fa fa-plus" aria-hidden="true"></i>
      </pl-button>
    </div>
  </div>
</template>
<script>
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';
  import VueTable from 'vuejs-spreadsheet';

  export default {
    data() {
      return {
        users_to_add: [],
        user_object: { name: '', email: '', role: '', site: '' },
        roles: [],
        school_users: [],
        default_role: 'student',
        csv_has_errors: false,
        csv_error_message: [],
        file_name: '',
        showFile: false,
        handlingFile: false,
        send_email: false,

        //VueTable data

        customOptions: {
          tbodyIndex: true,
          tbodyCheckbox: true,
          //sortHeader: true,
          trad: {
            lang: 'en',
            en: {
              select: {
                placeholder: 'Search by typing',
              },
            },
          },
          newData: {
            type: 'input',
            value: '',
            active: false,
            style: {
              color: '#000',
            },
          },
          fuseOptions: {
            //shouldSort: true,
            threshold: 0.2,
            location: 0,
            distance: 30,
            maxPatternLength: 64,
            minMatchCharLength: 1,
            findAllMatches: false,
            tokenize: false,
            keys: ['value'],
          },
        },
        submenuThead: [],
        disableCells: [],
        loading: false,
        parentScrollElement: {
          attribute: 'html',
          positionTop: 0,
        },
        selectPosition: {
          top: 0,
          left: 0,
        },
        disableSortThead: ['a'],
        styleWrapVueTable: {
          color: '15px',
        },
        headers: [
          {
            headerName: 'Name',
            headerKey: 'name',
            style: {
              width: '25%',
              minWidth: '25%',
              color: '#000',
            },
          },
          {
            headerName: 'Email',
            headerKey: 'email',
            style: {
              width: '25%',
              minWidth: '25%',
              color: '#000',
            },
          },
          {
            headerName: 'Role',
            headerKey: 'role',
            style: {
              width: '25%',
              minWidth: '25%',
              color: '#000',
            },
          },
          {
            headerName: 'Site',
            headerKey: 'site',
            style: {
              width: '25%',
              minWidth: '25%',
              color: '#000',
            },
          },
        ],
        usersToCheck: [
          {
            name: {
              type: 'input',
              value: '',
              active: false,
              style: {
                color: '#000',
                background: '',
              },
            },
            email: {
              type: 'input',
              value: '',
              active: false,
              style: {
                color: '#000',
                background: '',
              },
            },
            role: {
              type: 'select',

              style: {
                color: '#000',
                background: '',
              },
              selectOptions: [
                {
                  value: 'student',
                  label: 'Student',
                },
                {
                  value: 'teacher',
                  label: 'Teacher',
                },
              ],
              value: 'student',
              active: false,
            },
            site: {
              type: 'input',
              value: '',
              active: false,
              style: {
                color: '#000',
                background: '',
              },
            },
          },
        ],
        errors_count: 0,
        usersToRemove: [],
        removedAllUsers: false,
      };
    },
    components: {
      //VueExcelEditor,
      VueTable,
    },
    watch: {
      canImport() {
        EventBus.$emit('activeNext', this.canImport);
      },
    },
    computed: {
      // at least one column of one row filled and no errors
      canImport() {
        return (
          this.errors_count === 0 &&
          this.usersToCheck.length > 0 &&
          this.usersToCheck.map((x) => x.email).filter((e) => e.value !== '')
            .length > 0
        );
      },
    },
    methods: {
      resetFileUploader() {
        this.$refs.fileUploader.value = '';
        //this.discardFile();
      },
      emptyObject(obj) {
        for (let key in obj) {
          if (obj[key] !== '') return false;
        }
        return true;
      },
      discardFile() {
        this.resetFileUploader();
        this.showFile = false;
        this.errors_count = 0;
        this.users_to_add = this.users_to_add.filter((u) => u.csv === false);
        this.usersToCheck = this.users_to_add.slice();
        this.usersToRemove = [];
      },
      handleFiles() {
        let input = document.getElementById('files');
        let files = input.files;

        this.usersToRemove = [];
        this.handlingFile = true;

        if (files.length === 0) {
          return;
        }
        const file = files[0];

        let reader = new FileReader();
        this.file_name = file.name;
        reader.onload = (e) => {
          const file = e.target.result;
          const lines = file.split(/r\n|\n/);
          // Remove empty rows from excel
          this.addCsvUsers(lines.filter((l) => !!l));
        };

        for (let index = 0; index < this.users_to_add.length; index += 1) {
          const user = Object.assign({}, this.users_to_add[index]);
          delete user.csv;
          if (this.emptyObject(user)) {
            this.usersToRemove.push(index);
          }
        }

        this.deleteUser();

        reader.onloadend = () => {
          this.showFile = true;
          this.removedAllUsers = false;
          this.handlingFile = false;
        };

        reader.onerror = (e) => console.log(e.target.error.name);

        reader.readAsText(file, 'ISO-8859-1');
      },
      addCsvUsers(rows) {
        let fields = rows[0].split(',').map((field) => {
          return field.trim();
        });
        let user_fields = Object.keys(this.user_object);
        if (!this.arraysEqual(fields, user_fields)) {
          return;
        }
        for (let index = 1; index < rows.length; index += 1) {
          let row = rows[index].split(',').map((row) => {
            return row.trim();
          });

          let user = {};
          user[fields[0]] = row[0];
          for (let j = 1; j < fields.length; j += 1) {
            if (row[j]) {
              user[fields[j]] = row[j].toLowerCase();
            }
          }

          this.sendUserDataToTable(user);
        }
        //removes all users without email
        this.users_to_add = this.users_to_add.filter((u) => !!u.email);
      },
      handleSelect(event) {
        this.send_email = event;
        EventBus.$emit('saveUsers', this.usersToCheck, this.send_email);
      },
      sendUserDataToTable(user) {
        const pushUser = {
          email: { value: user.email, style: { color: '#000' } },
          name: { value: user.name, style: { color: '#000' } },
          role: { value: user.role, style: { color: '#000' } },
          site: { value: user.site, style: { color: '#000' } },
        };

        if (this.isAlreadySchoolUser(user.email)) {
          //this.errors_count++;
          pushUser.email.style.background = '#fffdd0';
        } else if (!user.email) {
          this.errors_count++;
          pushUser.email.style.background = '#ffcccb';
        } else if (!this.isAnEmail(user.email)) {
          this.errors_count++;
          pushUser.email.style.color = '#ff0000';
        }

        if (user.role) {
          if (user.role !== 'student' && user.role !== 'teacher') {
            this.errors_count++;
            pushUser.role.style.color = '#ffa500';
          } else {
            pushUser.role.style.color = '#000';
          }
        } else {
          this.errors_count++;
          pushUser.role.style.background = '#ffcccb';
        }

        this.usersToCheck.push(pushUser);

        const csvPushUser = Object.assign({}, pushUser);
        csvPushUser.csv = true;
        this.users_to_add.push(csvPushUser);

        if (this.errors_count === 0) {
          EventBus.$emit('saveUsers', this.usersToCheck, this.send_email);
        }
      },
      addRow() {
        const pushUser = {
          email: '',
          name: '',
          role: '',
          site: '',
        };
        this.usersToCheck.push(pushUser);
        const customPushUser = Object.assign({}, pushUser);
        customPushUser.csv = false;
        this.users_to_add.push(customPushUser);
      },
      isAnEmail(email) {
        email = email.toLowerCase().trim();
        var regex =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
      },
      arraysEqual(a, b) {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length !== b.length) return false;
        for (var i = 0; i < a.length; ++i) {
          if (a[i].trim() !== b[i].trim()) return false;
        }
        return true;
      },
      getRoleWithLessPermissions(role1, role2) {
        if (role1 === 'teacher' && role2 === 'student') {
          return 'student';
        }
        if (role1 === 'student' && role2 === 'teacher') {
          return 'student';
        }
        return this.default_role;
      },
      isAlreadySchoolUser(email) {
        return this.school_users.find((x) => x.email === email);
      },
      getAllSchoolUsersEmails() {
        adminServices
          .getUsersEmailsOfSchool(this.$route.params.schoolID)
          .then(({ data }) => {
            this.school_users = data;
          })
          .catch(console.error);
      },
      checkRowEmpty(user) {
        let data = '';
        const keys = Object.keys(user);
        delete keys[keys.length - 1];
        keys.forEach((key) => {
          data += user[key].value.trim();
        });
        return data === '';
      },
      changeData(row) {
        let increaseErrorsCount = false;
        if (this.checkRowEmpty(this.usersToCheck[row])) {
          this.usersToCheck[row].role.style.background = '#fff';
          this.usersToCheck[row].role.style.color = '#000';
          this.usersToCheck[row].email.style.color = '#000';
          this.usersToCheck[row].email.style.background = '#fff';
          return;
        }
        if (this.usersToCheck[row].email.value) {
          if (!this.isAlreadySchoolUser(this.usersToCheck[row].email.value)) {
            this.usersToCheck[row].email.style.color = '#000';
            this.usersToCheck[row].email.style.background = '#fff';
            if (this.isAnEmail(this.usersToCheck[row].email.value)) {
              this.usersToCheck[row].email.style.color = '#000';
              this.usersToCheck[row].email.style.background = '#fff';
            } else {
              increaseErrorsCount = true;
              this.usersToCheck[row].email.style.color = '#ff0000';
              this.usersToCheck[row].email.style.background = '#fff';
            }
          } else {
            this.usersToCheck[row].email.style.background = '#fffdd0';
          }
        } else {
          increaseErrorsCount = true;
          this.usersToCheck[row].email.style.background = '#ffcccb';
        }
        if (increaseErrorsCount) {
          this.errors_count++;
        }
        let increaseErrorsRoleCount = false;
        if (
          this.usersToCheck[row].role.value.trim().toLowerCase() ===
            'teacher' ||
          this.usersToCheck[row].role.value.trim().toLowerCase() === 'student'
        ) {
          this.usersToCheck[row].role.style.background = '#fff';
          this.usersToCheck[row].role.style.color = '#000';
        } else if (!this.usersToCheck[row].role.value) {
          increaseErrorsRoleCount = true;
          this.usersToCheck[row].role.style.background = '#ffcccb';
        } else {
          increaseErrorsRoleCount = true;
          this.usersToCheck[row].role.style.background = '#fff';
          this.usersToCheck[row].role.style.color = '#ffa500';
        }

        if (increaseErrorsRoleCount) {
          this.errors_count++;
        }

        if (this.errors_count === 0) {
          EventBus.$emit('saveUsers', this.usersToCheck, this.send_email);
        }
      },
      sortProduct() {},
      deleteUser() {
        this.usersToRemove = this.usersToRemove.sort(function (a, b) {
          return b - a;
        });
        this.usersToRemove.forEach((user_index) => {
          this.usersToCheck.splice(user_index, 1);
          this.users_to_add.splice(user_index, 1);
        });
        this.checkErrorsInTable();
        this.usersToRemove = [];
        if (this.usersToCheck.length === 0) {
          this.discardFile();
          this.removedAllUsers = true;
        }
      },
      checkErrorsInTable() {
        this.errors_count = 0;
        this.usersToCheck.forEach((user) => {
          const index = this.usersToCheck.indexOf(user);
          this.changeData(index);
        });
      },
      checkedAllData(isChecked) {
        this.usersToRemove = [];
        let index = '';
        if (isChecked) {
          this.usersToCheck.forEach((user) => {
            index = this.usersToCheck.indexOf(user);
            this.usersToRemove.push(index);
          });
        } else {
          this.usersToRemove = [];
        }
      },
      checkedData(row) {
        const index = this.usersToCheck.indexOf(row);
        const indexRemove = this.usersToRemove.indexOf(index);
        if (row.vuetable_checked) this.usersToRemove.push(index);
        else this.usersToRemove.splice(indexRemove, 1);
      },
    },
    created() {},
    mounted() {
      this.usersToCheck = [];
      this.getAllSchoolUsersEmails();
      for (let index = 0; index < 4; index += 1) {
        this.addRow();
      }
    },
  };
</script>
<style lang="stylus" scoped>
    @import '~app/global-stylus.styl';

  .topics
    font-size: 18px
    line-height: 32px
    font-weight: 550
  .topic-link
    color: pl-primary
    cursor: pointer

  .disable_upload
    cursor: default
    color: silver

  .warning-text
    font-size: 12px

  .yellow-alert
    border-radius: 0px
    background: #fffdd0
    padding: 2px 5px
    width:30px
    height: 20px

  .red-warning
    border-radius: 0px
    background: #ffcccb
    padding: 2px 5px
    width:30px
    height: 20px

  .text-red
    color: #ff0000

  .text-orange
    color: #ffa500

  .remove_btn
    cursor: pointer
    color: black

  .disable_remove
    cursor: default
    color: silver
</style>



// WEBPACK FOOTER //
// addUsersSecondStep.vue?3981fb9b